import React from 'react';
import AppWithRouter from './AppWithRouter';

function App() {
  return <AppWithRouter />;
}

export default App; 
